<script lang="ts" setup>
import { computed, ref } from "vue";

const props = defineProps({
  comment: {
    type: String,
    required: true
  },
  maxLength: {
    type: Number,
    required: true
  }
});

const isCommentExpanded = ref(false);

const isFullCommentVisible = computed(() => {
  return isCommentExpanded.value || props.comment.length <= props.maxLength;
});

const truncatedComment = computed(() => {
  return props.comment.slice(0, props.maxLength);
});

const expandComment = () => {
  isCommentExpanded.value = true;
};
</script>

<template>
  <template v-if="isFullCommentVisible">
    {{ props.comment }}
  </template>
  <template v-else>
    {{ truncatedComment }}
    ...
    <a href="#" @click.prevent="expandComment" class="text-blue">
      もっと見る
    </a>
  </template>
</template>
